
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"64","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32 8a5.112 5.112 0 014.481 2.652l.108.207 18.945 38.595a4.542 4.542 0 01-3.844 6.54l-.234.006H12.545a4.542 4.542 0 01-4.182-6.32l.102-.225 18.947-38.596A5.112 5.112 0 0132 8zm0 3c-.752 0-1.442.4-1.82 1.04l-.075.141-18.947 38.597a1.542 1.542 0 001.227 2.214l.159.008h38.913a1.543 1.543 0 001.447-2.077l-.063-.146-18.945-38.596A2.112 2.112 0 0032 11.001zm0 33l.245.013a2.25 2.25 0 11-.49 0L32 44zm0-21a1.5 1.5 0 011.486 1.296l.014.204v15a1.5 1.5 0 01-2.986.204L30.5 39.5v-15A1.5 1.5 0 0132 23z","fill":"#12181D","fill-rule":"evenodd"}})])
          )
        }
      }
    